import { AxiosPromise, AxiosStatic } from "axios";
import { ClientEvent, GetEventsInput } from "../types";

export const getEvents =
  (serverURL: string, appAxios: AxiosStatic) =>
  async (data?: GetEventsInput): AxiosPromise<ClientEvent[]> => {
    const params: Record<string, string | number | string[]> = {};
    if (data?.format !== undefined) {
      params.format = data.format;
    }
    if (data?.fromDate !== undefined) {
      params.fromDate = data.fromDate;
    }
    if (data?.toDate !== undefined) {
      params.toDate = data.toDate;
    }
    if (data?.dealIds?.length) {
      params.dealIds = data.dealIds;
    }
    if (data?.page !== undefined) {
      params.page = data.page;
    }
    if (data?.pageSize !== undefined) {
      params.pageSize = data.pageSize;
    }

    return await appAxios.get(`${serverURL}/events`, {
      params,
      withCredentials: true,
    });
  };

export const getEventById =
  (serverURL: string, appAxios: AxiosStatic) =>
  async (eventId: string): AxiosPromise<ClientEvent> =>
    await appAxios.get(`${serverURL}/events/${eventId}`, {
      withCredentials: true,
    });
